/*
  ALAC accessibility shims for legacy markup that is not ours to rewrite in place.
  - Home roast tabs (div role="tab" in sections/feature-products-homepage-c.liquid): make them a
    real keyboard tablist (one tab stop, arrows/Home/End move and select, aria-selected), and give
    the scroll arrows button semantics. Inert when the markup is absent.
  - Focus not obscured (WCAG 2.4.11): when keyboard focus lands on page content that sits under a
    fixed overlay at the bottom of the screen (scroll-to-top button, chat launcher, Google badge,
    sticky add-to-cart bar), scroll the page so the focused control is in view.
*/
(function () {
  function sync(list) {
    list.querySelectorAll('[role="tab"]').forEach(function (tab) {
      var on = tab.classList.contains('oc-active');
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    });
  }
  function initTabs() {
    document.querySelectorAll('.oc__product-tabs[role="tablist"]').forEach(function (list) {
      if (list.dataset.alacA11y) return;
      list.dataset.alacA11y = '1';
      if (!list.hasAttribute('aria-label')) list.setAttribute('aria-label', 'Choose a roast');
      sync(list);
      new MutationObserver(function () { sync(list); }).observe(list, { subtree: true, attributes: true, attributeFilter: ['class'] });
      list.addEventListener('keydown', function (event) {
        var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
        var i = tabs.indexOf(event.target);
        if (i < 0) return;
        var next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
        else if (event.key === 'Home') next = tabs[0];
        else if (event.key === 'End') next = tabs[tabs.length - 1];
        else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.target.click(); return; }
        if (!next) return;
        event.preventDefault();
        next.click();
        next.focus();
      });
    });
    document.querySelectorAll('.oc__product_tab-arrow').forEach(function (arrow) {
      if (arrow.getAttribute('role') === 'button') return;
      arrow.setAttribute('role', 'button');
      arrow.tabIndex = 0;
      arrow.setAttribute('aria-label', arrow.classList.contains('tab-arrow-left') ? 'Previous roast' : 'Next roast');
      var svg = arrow.querySelector('svg');
      if (svg) svg.setAttribute('aria-hidden', 'true');
      arrow.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); arrow.click(); }
      });
    });
  }
  function fixedAncestor(node) {
    for (var n = node; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      if (getComputedStyle(n).position === 'fixed') return n;
    }
    return null;
  }
  document.addEventListener('focusin', function (event) {
    var target = event.target;
    if (!target || !target.getBoundingClientRect || !target.closest('main, footer') || target.matches('main, footer')) return;
    if (target.closest('cart-drawer, [role="dialog"], details[open] .menu-drawer') || fixedAncestor(target)) return;
    if (!target.matches(':focus-visible')) return;
    requestAnimationFrame(function () {
      var r = target.getBoundingClientRect();
      if (target.matches('input[type="radio"], input[type="checkbox"]') && target.labels && target.labels[0]) r = target.labels[0].getBoundingClientRect();
      if (!r.width || !r.height || r.height > innerHeight) return;
      var lowest = innerHeight;
      [[r.left + r.width / 2, r.top + r.height / 2], [r.left + 3, r.bottom - 3], [r.right - 3, r.bottom - 3]].forEach(function (pt) {
        if (pt[1] < 0 || pt[1] > innerHeight) return;
        var hit = document.elementFromPoint(pt[0], pt[1]);
        if (!hit || target.contains(hit) || hit.contains(target) || (target.labels && target.labels[0] && target.labels[0].contains(hit))) return;
        var fixed = fixedAncestor(hit);
        if (fixed && fixed.getBoundingClientRect().top > innerHeight / 2) lowest = Math.min(lowest, fixed.getBoundingClientRect().top);
      });
      if (lowest < innerHeight && r.bottom > lowest - 4) window.scrollBy(0, r.bottom - lowest + 16);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTabs);
  else initTabs();
})();
